
export const environment = {
  production: true,
  apiurl : 'https://api.careergraph.com',
  accessToken: 'token'
};
